import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { addSurgeryDates, removeSurgeryDates } from '../handlers/calendarHandlers';

const useSurgeryDatesEffect = (surgeryDates, visibleDateRange, callOrderOrCalendar) => {
    useEffectWithErrorLogging(() => {
        addSurgeryDates(surgeryDates, visibleDateRange);
        return () => {
            removeSurgeryDates();
        };
    }, [visibleDateRange, surgeryDates, callOrderOrCalendar]);
};

export default useSurgeryDatesEffect;
